import {HasProjectMixin} from "./mixins/HasProjectMixin.jsx";
import {Model} from "@bryntum/schedulerpro";

export class ViewFolder extends HasProjectMixin(Model) {

  static get fields() {
    return [
      { name: "userId", dataSource: "user_id", type: 'number' },
      { name: "boardId", dataSource: "board_id", type: 'number' },
      { name: "name", dataSource: "name" },
      { name: "iconId", dataSource: "icon", type: "number" },
      { name: "type", dataSource: "type", type: "number"},
      { name: "color", dataSource: "color" },
      { name: "viewCount", dataSource: "view_count" },
      { name: "isDefaultFolder", persist: false, readOnly: true },
    ];
  }
}
